module.exports = __webpack_public_path__ + "img/icon_jth.c8795ee7.png";